<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";
import pekerjaanList from "@/data/pekerjaan";
import Multiselect from "vue-multiselect";

export default {
	name: "compUmat",
	props: ["triggerValidation"],
	components: { Multiselect },
	data() {
		return {
			myData: {},
			myOptions: {
				kriteria: umatOpt.kriteria,
				jk: umatOpt.jk,
				gol_darah: umatOpt.golDarah,
				agama: umatOpt.agama,

				pendidikan: umatOpt.pendidikan,
				statusKawin: umatOpt.statusKawin,
				cacatTubuh: umatOpt.cacatTubuh,
				pekerjaan: pekerjaanList,
				suku: umatData.suku,
				jurusan: umatData.jurusan,
				aktivitas: umatData.aktivitas,
				paroki: umatData.paroki,
				keuskupan: umatData.keuskupan,
				kabupaten: umatData.kabupaten,
				kecamatan: umatData.kecamatan,
				desa: umatData.desa,
				profesi: umatOpt.profesi,
				keterampilan: umatOpt.keterampilan,
				peran_lingkungan: umatOpt.peranLingkungan,
				peran_masyarakat: umatOpt.peranMasyarakat,
				peran_gereja: umatOpt.peranGereja,
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatItem: (state) => state.umat.item,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		triggerValidation: function (_newVal, _oldVal) {
			this.trigger();
		},
	},
	methods: {
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateStateCustom(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				if (this.veeErrors.has(ref)) {
					return { "is-invalid": true };
				} else {
					return { "is-valid": true };
				}
			}
			return null;
		},
		trigger() {
			this.$emit("validate", this.$validator.validateAll());
			this.$validator.validateAll();
		},
		addTag(newTag) {
			const tag = {
				text: newTag,
				value: newTag,
			};
			this.myOptions.profesi.push(tag);
			this.umatItem.profesi.push(tag);
		},
		addTagKeterampilan(newTag) {
			const tag = {
				text: newTag,
				value: newTag,
			};
			this.myOptions.keterampilan.push(tag);
			this.umatItem.keterampilan.push(tag);
		},
		addTagPeranLingkungan(newTag) {
			const tag = {
				text: newTag,
				value: newTag,
			};
			this.myOptions.keterampilan.push(tag);
			this.umatItem.peran_lingkungan.push(tag);
		},
		addTagPeranMasyarakat(newTag) {
			const tag = {
				text: newTag,
				value: newTag,
			};
			this.myOptions.keterampilan.push(tag);
			this.umatItem.peran_masyarakat.push(tag);
		},
		addTagPeranGereja(newTag) {
			const tag = {
				text: newTag,
				value: newTag,
			};
			this.myOptions.keterampilan.push(tag);
			this.umatItem.peran_gereja.push(tag);
		},
	},
};
</script>

<template>
	<div class="form theme-form">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>Nama <span class="text-danger">*</span></label>
					<b-form-input
						name="umat_nama"
						v-model="umatItem.nama"
						v-validate="{ required: true }"
						:state="validateState('umat_nama')"
						data-vv-as="Nama"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("umat_nama")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Wilayah <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="keuskupan"
						:class="validateStateCustom('keuskupan')"
						data-vv-as="Wilayah"
						v-validate="{ required: true }"
						v-model="umatItem.keuskupan"
						:minMatchingChars="1"
						:data="myOptions.keuskupan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("keuskupan")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Paroki <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="paroki"
						:class="validateStateCustom('paroki')"
						data-vv-as="Paroki"
						v-validate="{ required: true }"
						v-model="umatItem.paroki"
						:minMatchingChars="1"
						:data="myOptions.paroki"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("paroki")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label
						>Lingkungan/Stasi <span class="text-danger">*</span></label
					>
					<vue-typeahead-bootstrap
						name="lingkungan_stasi"
						:class="validateStateCustom('lingkungan_stasi')"
						data-vv-as="Lingkungan/Stasi"
						v-validate="{ required: true }"
						v-model="umatItem.lingkungan_stasi"
						:minMatchingChars="1"
						:data="lingkunganStasi"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("lingkungan_stasi")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Agama <span class="text-danger">*</span></label>
					<b-form-select
						name="agama"
						:state="validateState('agama')"
						data-vv-as="Agama"
						v-validate="{ required: true }"
						v-model="umatItem.agama"
						:options="myOptions.agama"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("agama")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Jenis Kelamin <span class="text-danger">*</span></label>
					<b-form-select
						name="jk"
						:state="validateState('jk')"
						data-vv-as="Jenis Kelamin"
						v-validate="{ required: true }"
						v-model="umatItem.jk"
						:options="myOptions.jk"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("jk")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Tempat Lahir <span class="text-danger">*</span></label>
					<b-form-input
						name="tempat_lahir"
						v-model="umatItem.tempat_lahir"
						v-validate="{ required: true }"
						:state="validateState('tempat_lahir')"
						data-vv-as="Tempat Lahir"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tempat_lahir")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Tanggal Lahir <span class="text-danger">*</span></label>
					<b-form-input
						name="tgl_lahir"
						:state="validateState('tgl_lahir')"
						data-vv-as="Tanggal Lahir"
						v-validate="{ required: true }"
						v-model="umatItem.tgl_lahir"
						size="sm"
						type="date"
					></b-form-input>
					<!-- <small tabindex="-1" class="form-text text-muted"
						>Format bulan/tanggal/tahun</small
					> -->
					<b-form-invalid-feedback>{{
						veeErrors.first("tgl_lahir")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Golongan Darah <span class="text-danger">*</span></label>
					<b-form-select
						name="gol_darah"
						:state="validateState('gol_darah')"
						data-vv-as="Gol. Darah"
						v-validate="{ required: true }"
						v-model="umatItem.gol_darah"
						:options="myOptions.gol_darah"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("gol_darah")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Suku <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="suku"
						:class="validateStateCustom('suku')"
						data-vv-as="Suku"
						v-validate="{ required: true }"
						v-model="umatItem.suku"
						:minMatchingChars="1"
						:data="myOptions.suku"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("suku")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Status Nikah<span class="text-danger">*</span></label>
					<b-form-select
						name="status_kawin"
						:state="validateState('status_kawin')"
						data-vv-as="Status Nikah"
						v-validate="{ required: true }"
						v-model="umatItem.status_kawin"
						:options="myOptions.statusKawin"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("status_kawin")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-3">
				<div class="form-group">
					<label>Pendidikan <span class="text-danger">*</span></label>
					<b-form-select
						name="pendidikan"
						:state="validateState('pendidikan')"
						data-vv-as="Pendidikan"
						v-validate="{ required: true }"
						v-model="umatItem.pendidikan"
						:options="myOptions.pendidikan"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("pendidikan")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Jurusan </label>
					<vue-typeahead-bootstrap
						name="jurusan"
						:class="validateStateCustom('jurusan')"
						data-vv-as="Jurusan"
						v-validate="{ required: false }"
						v-model="umatItem.jurusan"
						:minMatchingChars="1"
						:data="myOptions.jurusan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("jurusan")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Aktivitas Sosial </label>
					<vue-typeahead-bootstrap
						name="aktivitas"
						:class="validateStateCustom('aktivitas')"
						data-vv-as="Aktivitas Sosial"
						v-validate="{ required: false }"
						v-model="umatItem.aktivitas"
						:minMatchingChars="1"
						:data="myOptions.aktivitas"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("aktivitas")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>No HP </label>
					<b-form-input
						name="nohp"
						:state="validateState('nohp')"
						data-vv-as="No. HP"
						v-validate="{ required: false }"
						v-model="umatItem.nohp"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("nohp")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Email</label>
					<b-form-input
						name="email"
						:state="validateState('email')"
						data-vv-as="Email"
						v-validate="{ required: false }"
						v-model="umatItem.email"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("email")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>NIK</label>
					<b-form-input
						name="nik"
						:state="validateState('nik')"
						data-vv-as="NIK"
						v-validate="{ required: false }"
						v-model="umatItem.nik"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("nik")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-3">
				<div class="form-group">
					<label>Pekerjaan <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="pekerjaan"
						:class="validateStateCustom('pekerjaan')"
						data-vv-as="Pekerjaan"
						v-validate="{ required: true }"
						v-model="umatItem.pekerjaan"
						:minMatchingChars="1"
						:data="myOptions.pekerjaan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("pekerjaan")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Kota/Kabupaten <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="kabupaten"
						:class="validateStateCustom('kabupaten')"
						data-vv-as="Kota/Kabupaten"
						v-validate="{ required: true }"
						v-model="umatItem.kabupaten"
						:minMatchingChars="1"
						:data="myOptions.kabupaten"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("kabupaten")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Kecamatan <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="kecamatan"
						:class="validateStateCustom('kecamatan')"
						data-vv-as="Kecamatan"
						v-validate="{ required: true }"
						v-model="umatItem.kecamatan"
						:minMatchingChars="1"
						:data="myOptions.kecamatan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("kecamatan")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Kelurahan/Desa <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="desa"
						:class="validateStateCustom('desa')"
						data-vv-as="Kelurahan/Desa"
						v-validate="{ required: true }"
						v-model="umatItem.desa"
						:minMatchingChars="1"
						:data="myOptions.desa"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("desa")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Alamat <span class="text-danger">*</span></label>
					<b-form-textarea
						name="alamat"
						:state="validateState('alamat')"
						data-vv-as="Alamat"
						v-validate="{ required: true }"
						v-model="umatItem.alamat"
						size="sm"
					></b-form-textarea>

					<b-form-invalid-feedback>{{
						veeErrors.first("alamat")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Profesi </label>
					<multiselect
						name="profesi"
						v-validate="{ required: false }"
						:class="validateStateCustom('profesi')"
						data-vv-as="Profesi"
						v-model="umatItem.profesi"
						tag-placeholder="Tambah profesi"
						placeholder=""
						selectLabel="Pilih profesi"
						deselectLabel="Hapus profesi"
						selectedLabel="Terpilih"
						label="text"
						track-by="value"
						:options="myOptions.profesi"
						:multiple="true"
						:taggable="true"
						@tag="addTag"
					></multiselect>

					<b-form-invalid-feedback>{{
						veeErrors.first("profesi")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Keterampilan </label>
					<multiselect
						name="keterampilan"
						v-validate="{ required: false }"
						:class="validateStateCustom('keterampilan')"
						data-vv-as="keterampilan"
						v-model="umatItem.keterampilan"
						tag-placeholder="Tambah Keterampilan"
						placeholder=""
						selectLabel="Pilih Keterampilan"
						deselectLabel="Hapus Keterampilan"
						selectedLabel="Terpilih"
						label="text"
						track-by="value"
						:options="myOptions.keterampilan"
						:multiple="true"
						:taggable="true"
						@tag="addTagKeterampilan"
					></multiselect>

					<b-form-invalid-feedback>{{
						veeErrors.first("keterampilan")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Cacat Tubuh<span class="text-danger">*</span></label>
					<b-form-select
						name="cacat_tubuh"
						:state="validateState('cacat_tubuh')"
						data-vv-as="Cacat Tubuh"
						v-validate="{ required: true }"
						v-model="umatItem.cacat_tubuh"
						:options="myOptions.cacatTubuh"
						size="sm"
					></b-form-select>

					<b-form-invalid-feedback>{{
						veeErrors.first("cacat_tubuh")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
		<hr />
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>Nama Ayah</label>
					<b-form-input
						name="ayah"
						:state="validateState('ayah')"
						data-vv-as="No. HP"
						v-validate="{ required: false }"
						v-model="umatItem.ayah"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("ayah")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Nama Ibu</label>
					<b-form-input
						name="ibu"
						:state="validateState('ibu')"
						data-vv-as="Ibu"
						v-validate="{ required: false }"
						v-model="umatItem.ibu"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("ibu")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
		<hr />
		<h6 class="text-muted">Peran Dalam Geraja Dan Masyarakat:</h6>
		<hr />
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>Lingkungan/wilayah </label>
					<multiselect
						name="peran_lingkungan"
						v-validate="{ required: false }"
						:class="validateStateCustom('peran_lingkungan')"
						data-vv-as="Peran Lingkungan/Wilayah"
						v-model="umatItem.peran_lingkungan"
						tag-placeholder="Tambah Peran"
						placeholder=""
						selectLabel="Pilih Peran"
						deselectLabel="Hapus Peran"
						selectedLabel="Terpilih"
						label="text"
						track-by="value"
						:options="myOptions.peran_lingkungan"
						:multiple="true"
						:taggable="true"
						@tag="addTagPeranLingkungan"
					></multiselect>

					<b-form-invalid-feedback>{{
						veeErrors.first("peran_lingkungan")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Masyarakat </label>
					<multiselect
						name="peran_masyarakat"
						v-validate="{ required: false }"
						:class="validateStateCustom('peran_masyarakat')"
						data-vv-as="Peran Masyarakat"
						v-model="umatItem.peran_masyarakat"
						tag-placeholder="Tambah Peran"
						placeholder=""
						selectLabel="Pilih Peran"
						deselectLabel="Hapus Peran"
						selectedLabel="Terpilih"
						label="text"
						track-by="value"
						:options="myOptions.peran_masyarakat"
						:multiple="true"
						:taggable="true"
						@tag="addTagPeranMasyarakat"
					></multiselect>

					<b-form-invalid-feedback>{{
						veeErrors.first("peran_masyarakat")
					}}</b-form-invalid-feedback>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Gereja </label>
					<multiselect
						name="peran_gereja"
						v-validate="{ required: false }"
						:class="validateStateCustom('peran_gereja')"
						data-vv-as="Peran Gereja"
						v-model="umatItem.peran_gereja"
						tag-placeholder="Tambah Peran"
						placeholder=""
						selectLabel="Pilih Peran"
						deselectLabel="Hapus Peran"
						selectedLabel="Terpilih"
						label="text"
						track-by="value"
						:options="myOptions.peran_gereja"
						:multiple="true"
						:taggable="true"
						@tag="addTagPeranGereja"
					></multiselect>

					<b-form-invalid-feedback>{{
						veeErrors.first("peran_gereja")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
	</div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
::v-deep .multiselect__tags {
	border: 1px solid #1d71b8 !important;
	min-height: 31px !important;
	padding: 2px 26px 0px 10px !important;
	font-size: 12px !important;
}
::v-deep .multiselect__tag {
	margin-top: 2.5px !important;
	margin-bottom: 0px !important;
	background: #0071b3 !important;
}

::v-deep .multiselect__select {
	height: 30px !important;
	display: none;
}

::v-deep .multiselect__placeholder {
	margin-bottom: 4px !important;
	font-size: 14px !important;
}

::v-deep multiselect__tag-icon {
	line-height: 18px !important;
}

::v-deep .multiselect__tag-icon::after {
	color: #fff !important;
}
::v-deep .multiselect__tag-icon:focus,
::v-deep .multiselect__tag-icon:hover {
	background: #0098f0 !important;
}
::v-deep .multiselect__option--highlight {
	background: #0071b3 !important;
}
::v-deep .multiselect__option--highlight::after {
	background: #0071b3 !important;
}
::v-deep .multiselect {
	font-size: 14px;
}
</style>